import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { FiCheckCircle, FiArrowRight } from 'react-icons/fi';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const sessionId = new URLSearchParams(location.search).get('session_id');

    useEffect(() => {
        // Auto-redirect to home after 8 seconds
        const timer = setTimeout(() => {
            navigate('/home');
        }, 8000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="min-h-screen bg-bg_primary flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center">
                {/* Animated success icon */}
                <div className="flex items-center justify-center mb-8">
                    <div
                        style={{
                            width: 100,
                            height: 100,
                            borderRadius: '50%',
                            background: 'rgba(34,197,94,0.12)',
                            border: '2px solid rgba(34,197,94,0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            animation: 'pulse 2s infinite',
                        }}
                    >
                        <FiCheckCircle style={{ color: '#22c55e', fontSize: 48 }} />
                    </div>
                </div>

                <h1
                    style={{
                        fontSize: '2rem',
                        fontWeight: 700,
                        color: '#ffffff',
                        marginBottom: '0.75rem',
                    }}
                >
                    Payment Successful!
                </h1>

                <p
                    style={{
                        color: '#9ca3af',
                        fontSize: '1rem',
                        lineHeight: 1.6,
                        marginBottom: '2rem',
                    }}
                >
                    Your subscription has been activated successfully. You now have full
                    access to all the features included in your plan.
                </p>

                {sessionId && (
                    <div
                        style={{
                            background: 'rgba(34,197,94,0.07)',
                            border: '1px solid rgba(34,197,94,0.25)',
                            borderRadius: 10,
                            padding: '0.75rem 1rem',
                            marginBottom: '2rem',
                        }}
                    >
                        <p style={{ color: '#9ca3af', fontSize: '0.75rem', marginBottom: 4 }}>
                            Session ID
                        </p>
                        <p
                            style={{
                                color: '#22c55e',
                                fontSize: '0.8rem',
                                fontFamily: 'monospace',
                                wordBreak: 'break-all',
                            }}
                        >
                            {sessionId}
                        </p>
                    </div>
                )}

                <button
                    onClick={() => navigate('/home')}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 8,
                        background: '#22c55e',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 8,
                        padding: '0.75rem 2rem',
                        fontSize: '1rem',
                        fontWeight: 600,
                        cursor: 'pointer',
                        transition: 'background 0.2s',
                        marginBottom: '1.25rem',
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.background = '#16a34a')}
                    onMouseOut={(e) => (e.currentTarget.style.background = '#22c55e')}
                >
                    Go to Dashboard
                    <FiArrowRight />
                </button>

                <p style={{ color: '#6b7280', fontSize: '0.8rem' }}>
                    You will be redirected automatically in 8 seconds…
                </p>
            </div>

            <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.85; }
        }
      `}</style>
        </div>
    );
};

export default PaymentSuccess;
